<template>
  <v-card flat class="px-16 pb-16 pt-8" color="transparent">
    <v-card-text class="text-center mb-10 pwt-loading-message-text">
      {{ text ? text : "We're getting things ready for you..." }}
    </v-card-text>
    <v-card-text class="d-flex justify-center text-primary text-center mb-10">
      <LoadingCard :size="60" />
    </v-card-text>
  </v-card>
</template>
<script setup lang="ts">
import LoadingCard from './LoadingCard.vue';

const { text } = defineProps<{ text?: string }>()
</script>
<style scoped>
.pwt-loading-message-text {
  color: #161616;
  font-size: 20px;
  font-style: normal;
  font-weight: 300;
  line-height: 20px; /* 100% */
  letter-spacing: -0.5px;
}
</style>
